import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewInit,
  inject,
  input,
  effect
} from '@angular/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { filter, firstValueFrom, Subject, take } from 'rxjs';

import { ENVIRONMENT, Environment, EnvironmentService } from '@environment';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { LocationService } from '@usheru-hff/sdk/location';
import { MovieService } from '@usheru-hff/sdk/movie';
import {
  SHOWTIMES_INTERSECTION_CONFIG,
  STREAMING_INTERSECTION_CONFIG,
  TrackingService
} from '@usheru-hff/sdk/tracking';
import {
  Country,
  getMovieGenres,
  getMovieTags,
  Movie,
  MovieStreaming,
  StreamingPlatform
} from '@usheru-hff/shared/domain';
import { ShowtimeStreamingService } from '@usheru-hff/shared/utils-movie';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { UplayerService } from '@usheru-hff/uplayer/domain';

/**

 * Component that show cinemas from a location where a movie in available.

 *

 * //TODO barbeitoalex propostal - refractor name to something like "streaming-selector".

 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.

 * //TODO barbeitoalex propostal - move component folder to the root of components

 * //TODO barbeitoalex propostal - update translate text with an observable to the current language

 */

@Component({
  selector: 'ush-showtime-streaming-watch-at-home',
  templateUrl: './showtime-streaming-watch-at-home.component.html',
  styleUrls: ['./showtime-streaming-watch-at-home.component.scss']
})
export class ShowtimeStreamingWatchAtHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly environmentService = inject(EnvironmentService);

  /**
   * @docsNotRequired
   */

  movie = input<Movie>();

  @Input()
  showUsheruLogo: boolean;

  /**
   * @docsNotRequired
   */
  @Output()
  streamsChanged: EventEmitter<MovieStreaming[]> = new EventEmitter();

  /**
   * @docsNotRequired
   */
  @Output()
  streamingPlatformsLoaded: EventEmitter<boolean> = new EventEmitter();

  /**
   * Provided by {@link CollectionsService}.
   */
  country: Country;

  /**
   * @docsNotRequired
   */
  countries: Country[] = [];

  /**
   * Activates from {@link Environment} uPlayer.
   */
  uplayerEnabled: boolean;

  /**
   * @docsNotRequired
   */
  uplayerBtnVisible: boolean;

  /**
   * @docsNotRequired
   */
  streams: MovieStreaming[];

  errorMsg: string;

  /**
   * Status to know if it is waiting to update {@link streams}.
   */
  loadingStreams = true;

  /**
   * Active if {@link Channel} has disableShowtimes.
   */
  disableStreaming = false;

  faChevronDown = faChevronDown;

  dropdownIcon = this.environmentService.watchAtHomeComponent('dropdownIcon');

  unsubscriber = new Subject();
  private env: Environment = inject(ENVIRONMENT);
  readonly countryBasedDropdownEnabled = this.env.countryBasedApplication?.enabled;

  constructor(
    private location: LocationService,
    private channelService: ChannelService,
    private movieService: MovieService,
    private translationsService: TranslationsService,
    private trackingService: TrackingService,
    private showtimeStreamingService: ShowtimeStreamingService,
    private uplayerService: UplayerService,
    private cd: ChangeDetectorRef
  ) {
    this.disableStreaming = this.channelService.channel.settings.disableStreaming;

    effect(() => {
      if (this.movie()) {
        this.loadStreams();
      }
    });
  }

  /**
   * * Load counstries.
   *
   * * Check of uPlayer is enabled
   *
   * * Load streamigs
   *
   * //TODO barbeitoalex propostal - the loadStreams could be done only in ngOnChange
   */
  ngOnInit(): void {
    // check if has uplayerEnabled
    this.countries = this.location.getAvailableCountries();
    this.country = this.location.getAvailableCountrySelected(this.countries);
    this.uplayerEnabled = this.movie().hasPlayer;
  }

  ngAfterViewInit(): void {
    this.addStreamingVisibilityListener();
  }

  ngOnDestroy(): void {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  private addStreamingVisibilityListener(): void {
    const { eventName, querySelector } = STREAMING_INTERSECTION_CONFIG[this.env.appType];

    this.trackingService.usheruSdkTrack({
      kind: 'intersection',
      eventType: 'MovieStreaming',
      eventName,
      querySelector,
      payload: {
        event_category: 'MovieStreaming',
        label: `${this.movie().title} @ ${this.country.name}`,
        movie: this.movie().title,
        idMovie: this.movie().id,
        imdb: this.movie()?.imdb,
        tagsMovie: getMovieTags(this.movie()),
        genresMovie: getMovieGenres(this.movie()),
        country: this.country.name
      }
    });
  }

  onStreamingPlatformImgError(sp: StreamingPlatform) {
    sp.imgError = true;
  }

  /**
   * @docsNotRequired
   */
  onCountryChanged(country: Country) {
    if (country) {
      this.country = country;
      this.loadStreams();
      this.trackCountrySelected();
    }
  }

  trackCountrySelected() {
    this.trackingService.trackEvent({
      action: 'SelectCountry',
      properties: {
        category: 'MovieStreaming',
        label: `${this.movie().title} @ ${this.country.name}`,
        movie: this.movie().title,
        idMovie: this.movie().id,
        imdb: this.movie()?.imdb,
        tagsMovie: getMovieTags(this.movie()),
        genresMovie: getMovieGenres(this.movie()),
        country: this.country.name
      }
    });
  }

  /**
   * Listener for {@link UplayButtonComponent}.
   * @param event
   */
  onUplayButtonDisplayed(uplayVisible) {
    this.uplayerBtnVisible = uplayVisible;
  }

  /**
   * Get the streaming platforms to set in {@link streams} and sort them.
   *
   * //TODO barbeitoalex propostal - update to lastValueFrom
   */
  private loadStreams() {
    this.loadingStreams = true;

    if (this.country) {
      console.info('loadStreams this.movie().id', this.movie().id);
      console.info('loadStreams this.country.id', this.country.id);
      console.info('loadStreams this.country.name', this.country.name);
      firstValueFrom(
        this.movieService.getStreamingLinks({
          movieStreamingCountry: [this.country.id],
          movie: [this.movie().id]
        })
      )
        .then(movieStreams => {
          this.loadingStreams = false;

          movieStreams.sort((a, b) => {
            if (a.streamingPlatform.order != b.streamingPlatform.order) {
              return a.streamingPlatform.order - b.streamingPlatform.order;
            } else {
              return a.streamingPlatform.name.toLocaleLowerCase() > b.streamingPlatform.name.toLocaleLowerCase()
                ? 1
                : -1;
            }
          });

          this.streams = movieStreams;

          if (this.streams?.length > 0) {
            this.streamingPlatformsLoaded.emit(true);
          } else {
            this.errorMsg = this.showtimeStreamingService.getStreamingErrorMessage(this.country);
          }

          this.streamsChanged.emit([...this.streams]);

          this.cd.detectChanges();
        })

        .catch(err => {
          this.loadingStreams = false;

          console.error(err);

          this.cd.detectChanges();
        });
    }
  }

  /**
   * @docsNotRequired
   */
  setMyCountry() {
    this.location.findMyLocation().then(location => {
      this.country = this.location.getCountryByAddress(location.address);

      this.loadStreams();
    });
  }

  /**
   * @docsNotRequired
   * @param ms
   */
  onStreamingRedirect(ms: MovieStreaming) {
    this.trackingService.trackEvent({
      action: 'StreamingRedirect',

      properties: {
        category: 'MovieStreaming',

        label: `${ms.streamingPlatform.name} @ ${this.movie().title} @ ${ms.country.name}`,

        movie: this.movie().title,

        idMovie: this.movie().id,

        imdb: this.movie()?.imdb,
        tagsMovie: getMovieTags(this.movie()),
        genresMovie: getMovieGenres(this.movie()),

        country: ms.country.name,

        platform: ms.streamingPlatform.name
      }
    });
  }
}
